var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: { width: _vm.w, height: _vm.h },
      on: {
        touchmove: function($event) {
          $event.preventDefault()
        }
      }
    },
    [
      _c("canvas", {
        staticClass: "canvas",
        attrs: { id: _vm.uid, "data-uid": _vm.uid, disabled: _vm.disabled }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f62afaa", { render: render, staticRenderFns: staticRenderFns })
  }
}